if (!customElements.get('gift-swatches')) {
  class GiftSwatches extends HTMLElement {
    constructor() {
      super();

      this.swatches = null;
      this.swatchGroup = null;
      this.formId = null;
      this.productForm = null;
      this.inputs = null;
      this.isQuickAdd = null;
      this.emptySwatch = null;
      this.productFormFake = null;
    }

    connectedCallback() {
      this.formId = this.dataset.id;
      this.swatches = this.querySelectorAll('.product__swatch');
      this.swatchGroup = this.querySelectorAll('.gift__item');
      this.productForm = this.querySelector(`product-form[data-id="${this.formId}"]`) || document.querySelector(`product-info product-form[data-id="${this.formId}"]`);
      this.inputs = this.productForm.querySelectorAll(`input[data-product-id]`);
      this.isQuickAdd = this.closest('quick-add-modal') ? true : false;
      this.emptySwatch = this?.querySelector('.product__swatch_empty') || false;
      this.productFormFake = this?.querySelector('.gift-product-form-empty') || false;

      if(this.isQuickAdd) this.removeInputsDisabledState();
      this.swatches.forEach(swatch => swatch.addEventListener('click', event => this.handleSwatchClick(event)));
    }

    swapButtons(showPrimaryBtn = true) {
      console_log(showPrimaryBtn);
      if (showPrimaryBtn){
        this.productForm ? this.productForm.classList.remove('hidden') : false;
        this.productFormFake ? this.productFormFake.classList.add('hidden') : false;
      } else {
        this.productForm ? this.productForm.classList.add('hidden') : false;
        this.productFormFake ? this.productFormFake.classList.remove('hidden') : false;
      }
    }

    removeInputsDisabledState() {
      this.inputs.forEach(input => input.removeAttribute('disabled'));
    }

    handleSwatchClick(event) {
      const target = event.target.closest('.product__swatch');

      if (!target) return;

      const targetParent = target.closest('.product__swatches');
      const multiSelectionLimit = parseInt(targetParent.dataset?.limits) || 1;
      const productId = targetParent.dataset.productId;

      // Handle "clear all" (empty gift swatch)
      if (target.dataset.variantId === "false") {
          // Clear all active swatches
          targetParent.querySelectorAll('.product__swatch').forEach(swatch => {
              swatch.classList.remove('active');
              const counterEl = swatch.querySelector('.product__swatch-counter');
              if (counterEl) counterEl.textContent = "0";
          });

          // Set the "active" class for the empty swatch
          target.classList.add('active');

          // Disable all related inputs for this group
          this.updateFormInputs(productId, true);
          //this.swapButtons(false);
          return;
      }

      // Remove "active" state from empty swatch
      const emptySwatch = targetParent.querySelector('.product__swatch[data-variant-id="false"]');
      if (emptySwatch) {
          emptySwatch.classList.remove('active');
      }

      // Multi-selection logic
      if (multiSelectionLimit > 1) {
          const currentSelections = [...targetParent.querySelectorAll('.product__swatch.active')];
          let currentSelectionsSize = currentSelections.reduce((sum, swatch) => {
              const counterEl = swatch.querySelector('.product__swatch-counter');
              return sum + (counterEl ? parseInt(counterEl.textContent || "0", 10) : 0);
          }, 0);

          const counterEl = target.querySelector('.product__swatch-counter');
          let counterValue = counterEl ? parseInt(counterEl.textContent || "0", 10) : 0;

          // Adjust selections to stay within the limit
          if (currentSelectionsSize >= multiSelectionLimit && counterValue === 0) {
              const firstSelected = currentSelections[0];
              const firstCounterEl = firstSelected.querySelector('.product__swatch-counter');
              let firstCounterValue = parseInt(firstCounterEl.textContent || "0", 10);

              if (firstCounterValue > 0) {
                  firstCounterValue--;
                  firstCounterEl.textContent = firstCounterValue;
                  if (firstCounterValue === 0) {
                      firstSelected.classList.remove('active');
                  }
                  currentSelectionsSize--;
              }
          }

          // Update the counter for the clicked swatch
          if (currentSelectionsSize < multiSelectionLimit) {
              counterValue++;
              target.classList.add('active');
          } else if (counterValue > 0) {
              counterValue--;
              if (counterValue === 0) {
                  target.classList.remove('active');
              }
          }

          if (counterEl) {
              counterEl.textContent = counterValue;
          }
      } else {
          // Single-selection logic
          targetParent.querySelectorAll('.product__swatch').forEach(swatch => {
              swatch.classList.remove('active');
              const swatchCounterEl = swatch.querySelector('.product__swatch-counter');
              if (swatchCounterEl) swatchCounterEl.textContent = "0";
          });

          target.classList.add('active');
          const counterEl = target.querySelector('.product__swatch-counter');
          if (counterEl) counterEl.textContent = "1";
      }

      // Update inputs for this gift group
      this.updateFormInputs(productId);
      this.swapButtons(true);
    }

    updateFormInputs(productId, clearAll = false) {
      const allInputs = [...this.productForm.querySelectorAll('input[data-product-id]')];
      const productInputs = allInputs.filter(input => input.dataset.productId === productId);

      if (clearAll) {
          // Disable all inputs for the group
          productInputs.forEach(input => {
            input.setAttribute('disabled', '');
          });
          return;
      }

      const targetParent = this.querySelector(`.product__swatches[data-product-id="${productId}"]`);
      const selectedSwatches = [...targetParent.querySelectorAll('.product__swatch.active')];
      const isMultiSelectionGroup = targetParent.dataset.limits > 1; // Check if this is a multi-selection group

      let currentIndex = 0;

      selectedSwatches.forEach(swatch => {
          const variantId = swatch.dataset.variantId;
          const counter = parseInt(swatch.querySelector('.product__swatch-counter')?.textContent || "0", 10);

          if (isMultiSelectionGroup) {
              // Handle multi-selection groups: Map swatch to multiple inputs if its counter > 1
              for (let i = 0; i < counter; i++) {
                  const inputGroup = productInputs.filter(
                      input => input.dataset.multiSelectionIndex == currentIndex
                  );
                  inputGroup.forEach(input => {
                      if (input.name.endsWith('[id]')) {
                          input.value = variantId; // Update variantId
                      }
                      input.removeAttribute('disabled'); // Enable the input group
                  });
                  currentIndex++;
              }
          } else {
              // Handle single-selection groups: Update the first available input
              const inputGroup = productInputs.filter(input => !input.dataset.multiSelectionIndex);
              inputGroup.forEach(input => {
                  if (input.name.endsWith('[id]')) {
                      input.value = variantId; // Update variantId
                  }
                  input.removeAttribute('disabled'); // Enable the input group
              });
          }
      });

      // Disable unused inputs only for multi-selection groups
      if (isMultiSelectionGroup) {
          productInputs.forEach(input => {
              const index = parseInt(input.dataset.multiSelectionIndex || "0", 10);
              if (index >= currentIndex) {
                input.setAttribute('disabled', '');
              }
          });
      }
    }
  }

  customElements.define('gift-swatches', GiftSwatches);
}
